/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzGetPermissionsCatalogQueryResponse, UsersAuthzGetPermissionsCatalog401, UsersAuthzGetPermissionsCatalog403, UsersAuthzGetPermissionsCatalog500 } from "../models/UsersAuthzGetPermissionsCatalog";

export function getUsersAuthzGetPermissionsCatalogUrl() {
  const res = { method: 'GET', url: `/users-authz/v1/permissions-catalog` as const }
  return res
}

/**
 * @description Returns a comprehensive list of all permissions from all APIs grouped by source
 * @summary Get all available permissions across all APIs
 * {@link /users-authz/v1/permissions-catalog}
 */
export async function usersAuthzGetPermissionsCatalog(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<UsersAuthzGetPermissionsCatalogQueryResponse, ResponseErrorConfig<UsersAuthzGetPermissionsCatalog401 | UsersAuthzGetPermissionsCatalog403 | UsersAuthzGetPermissionsCatalog500>, unknown>({ method : "GET", url : getUsersAuthzGetPermissionsCatalogUrl().url.toString(), ... requestConfig })
  return res.data
}